"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.groupPrices = void 0;
var R = _interopRequireWildcard(require("ramda"));
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var tagMinOfferByNights = function tagMinOfferByNights(offers) {
  return R.call(R.pipe(R.groupBy(function (offer) {
    return offer.nights;
  }), R.toPairs, R.map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      groupedByNights = _ref2[1];
    return R.sort(function (offerA, offerB) {
      return offerA.price.uah - offerB.price.uah;
    }, groupedByNights);
  }), R.map(R.over(R.lensIndex(0), function (offer) {
    return R.set(R.lensProp('isMinPrice'), true, offer);
  })), R.flatten), offers);
};
var groupByDate = function groupByDate(offers) {
  return R.groupBy(function (offer) {
    return offer.date;
  }, offers);
};
var sortOffersByDate = function sortOffersByDate(groupedByDate) {
  return R.call(R.pipe(R.toPairs, R.sort(function (_ref3, _ref4) {
    var _ref5 = _slicedToArray(_ref3, 1),
      dateA = _ref5[0];
    var _ref6 = _slicedToArray(_ref4, 1),
      dateB = _ref6[0];
    return (0, _moment.default)(dateA).diff((0, _moment.default)(dateB), 'days');
  })), groupedByDate);
};
var groupOffersByNights = function groupOffersByNights(offers) {
  return R.call(R.map(R.over(R.lensProp('offers'), function (items) {
    return R.groupBy(function (item) {
      return item.nights;
    }, items);
  })), offers);
};
var sortOffersByNights = function sortOffersByNights(groupedByNights) {
  return R.call(R.map(R.over(R.lensProp('offers'), R.pipe(R.toPairs, R.sort(function (_ref7, _ref8) {
    var _ref9 = _slicedToArray(_ref7, 1),
      nightA = _ref9[0];
    var _ref0 = _slicedToArray(_ref8, 1),
      nightB = _ref0[0];
    return nightA - nightB;
  })))), groupedByNights);
};
var sortOffersByMinPrice = function sortOffersByMinPrice(offers) {
  return R.call(R.map(R.over(R.lensProp('offers'), R.map(function (groupsByNights) {
    return R.sort(R.ascend(R.path(['price', 'uah'])), groupsByNights);
  }))), offers);
};
var createOffersRow = function createOffersRow(nightsRange) {
  return function (offers) {
    return R.map(R.over(R.lensProp('offers'), function (items) {
      return R.map(function (nights) {
        return R.find(function (item) {
          return item.nights === nights;
        }, items);
      }, nightsRange);
    }), offers);
  };
};
var groupPrices = exports.groupPrices = function groupPrices(offers, nightsRange) {
  return R.call(R.when(Boolean, R.pipe(tagMinOfferByNights, groupByDate, sortOffersByDate, R.map(function (_ref1) {
    var _ref10 = _slicedToArray(_ref1, 2),
      date = _ref10[0],
      items = _ref10[1];
    return {
      date: date,
      offers: items
    };
  }), groupOffersByNights, sortOffersByNights, R.map(R.over(R.lensProp('offers'), R.map(function (_ref11) {
    var _ref12 = _slicedToArray(_ref11, 2),
      items = _ref12[1];
    return items;
  }))), sortOffersByMinPrice, R.map(R.over(R.lensProp('offers'), R.map(function (groupedByNights) {
    return groupedByNights[0];
  }))), createOffersRow(nightsRange))), offers);
};